export const ROUTE_ACCESS = {
  PUBLIC: 'public',
  PROTECTED: 'protected'
}

export const ROUTE_GROUP = {
  LOGIN: 'login',
  EMAIL: 'email'
}

export const ROUTE_REGISTRY = [
  { key: 'HOME', path: '/', access: ROUTE_ACCESS.PUBLIC },
  { key: 'LOGIN', path: '/login', access: ROUTE_ACCESS.PUBLIC, group: ROUTE_GROUP.LOGIN },
  { key: 'PHONE_OTP', path: '/otp', access: ROUTE_ACCESS.PUBLIC, group: ROUTE_GROUP.LOGIN },
  {
    key: 'LODGE_COMPLAINT',
    path: '/lodge-a-complaint',
    access: ROUTE_ACCESS.PUBLIC,
    products: ['CL']
  },
  {
    key: 'EMAIL_VERIFICATION',
    path: '/verify-email',
    access: ROUTE_ACCESS.PROTECTED,
    group: ROUTE_GROUP.EMAIL
  },
  {
    key: 'OTP_VERIFICATION',
    path: '/verify-otp',
    access: ROUTE_ACCESS.PROTECTED,
    group: ROUTE_GROUP.EMAIL
  },
  { key: 'VERIFICATION_STATUS', path: '/verification-status', access: ROUTE_ACCESS.PROTECTED }
]

export const INTERNAL_ROUTES = Object.fromEntries(
  ROUTE_REGISTRY.map(({ key, path }) => [key, path])
)

export const ROUTES = INTERNAL_ROUTES

export const EXTERNAL_ROUTES = {
  WEBSITE: '/',
  CASHLOAN_PROFILE: '/cashloan-profile'
}
